import React, { useState, useEffect } from 'react';
import Marquee from "react-fast-marquee";
import axios from 'axios';
import { useCookies } from 'react-cookie';

const SponsorsMarqueeV2 = ({ award_id }) => {
  const [cookies] = useCookies(['currentUser', 'isLoggedIn', 'userRole', 'token']);
  const currentUser = cookies.currentUser;
  const token = cookies.token;

  const [sponsors, setSponsors] = useState([]);
  const [sponsorsLoading, setSponsorsLoading] = useState(true);

  const getSponsors = async () => {
    return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}sponsorship/agreement?award_id=${award_id}`);
  };

  useEffect(() => {
    getSponsors()
      .then(response => {
        const selectedSponsors = response.data.data;
        if (selectedSponsors) {
          setSponsors(selectedSponsors);
        }
        setSponsorsLoading(false);
      })
      .catch(() => {
        console.log("Error getting sponsors");
        setSponsorsLoading(false);
      });
  }, []);

   // For PHA 2025 rearrange sponsor placement
  const logoOrder = ["Medforce", "Servisource", "Doctify", "Medica", "Amárach Research"];
  const logoOrderAIA2025 = ["Amarach Research", "Leasepoint", "Aviation Skillnet", "The 1878"];
  const logoOrderCXIA2025 = ["CXPA", "Amárach Research", "NiCE", "Fin by Intercom"];
  const logoOrderILTA2025 = ["AIB", "Maersk Contract Logistics", "ISM Recruitment & Training", "HSI Skillko", "Flexistaff Recruitment", "Excel Recruitment", "Manna Air Delivery", "Irish International Freight Association", "Amárach Research"];
  const logoOrderFM2026 = ["ECAT Group", "Tork®, an Essity brand", "Mitie Ireland", "SOS Group", "Sodexo", "Synergy Security Solutions", "CBRE Global Workplace Solutions (GWS) Ireland", "Panda", "FLEXÉIR Facilities Services", "ISS Ireland Ltd.", "Western Hygiene", "Berka Solutions and Mckeon Group", "Sensori", "ABM Ireland", "Kärcher Ireland", "Ascension Lifts", "Bidvest Noonan", "Portobello Institute", "Amárach Research"];
  const excludedFM2026Sponsor = ["Thorntons Recycling", "BAM Facilities Management", "EWL Electric", "MKF Property Services", "Transpoco"];
  const excludedHR2026Sponsor = ["Access Group","HR Hire"];
  const logoWIFA2026 = ["Amárach Research"];

  // FM Awards UK 2026 (award 151) - client-requested sponsor order
  const logoOrderFMUK2026 = ["ECAT Group", "Bidvest Noonan", "Elite M&E", "Zeelo", "Shoes For Crews (Europe)", "The Sunday Times", "Amárach Research"];

  const logoOrderHR2026 = ["DeCare Dental", "NFP Ireland Management", "EPI-USE", "Amárach Research"];

  // CXIA 2026 (award 162) - client-requested order: sponsors (TP, 8x8, CX Index),
  // then supporters (CXPA, Amárach). Business River's logo is appended at the end.
  const logoOrderCXIA2026 = ["TP Ireland", "8x8", "CX Index", "CXPA", "Amárach Research", "Amarach Research"];
  const excludedCXIA2026Sponsor = ["Abtran", "NiCE", "Fin by Intercom", "Workair"];

  // CXIA 2026 (award 162) - per-logo heights so the marquee reads level. TP is a tight
  // square mark, the 8x8 file has heavy padding around the text, and CX Index / CXPA
  // are wide wordmarks.
  const logoHeightsCXIA2026 = {
    "TP Ireland": "3.8vw",
    "8x8": "5.5vw",
    "CX Index": "2.2vw",
    "CXPA": "3.2vw",
    "Amárach Research": "3.6vw",
    "Amarach Research": "3.6vw",
    "Business River": "3.5vw",
  };

  // Awards whose marquee loads the original uploaded logo instead of the 200px-wide
  // thumbnail, which looks blurry once scaled up to the marquee height.
  const fullResLogoAwards = [162];

  // FM Awards UK 2026 (award 151) - per-logo heights so the marquee reads level.
  // Sized on the text/mark, not the bounding box: the logos run from 1:1 (ECAT) to
  // 11.9:1 (The Sunday Times), so an identical height would make the wide wordmarks
  // span most of the strip.
  const logoHeightsFMUK2026 = {
    "ECAT Group": "5.4vw",
    "Bidvest Noonan": "4vw",
    "Elite M&E": "3.8vw",
    "Zeelo": "3.1vw",
    "Shoes For Crews (Europe)": "3.4vw",
    "Amárach Research": "3.6vw",
    "Amarach Research": "3.6vw",
    "The Sunday Times": "1.7vw",
  };

  // Filter out unwanted sponsors
  let filteredSponsors = sponsors.filter(
    sponsor =>
      sponsor.id != 591 &&
      sponsor.id != 766 &&
      sponsor.id != 590 &&
      sponsor.id != 644 &&
      sponsor.id != 696 &&
      sponsor.id != 697 &&
      sponsor.id != 698 &&
      sponsor.id != 622 &&
      sponsor.id != 738 &&
      sponsor.id != 739 &&
      sponsor.id != 743 && 
      sponsor.id != 837 &&
      sponsor.id != 929 &&
      sponsor.id != 846 &&
      sponsor.company_name != "The Irish Times" &&
      !excludedFM2026Sponsor.includes(sponsor.company_name) &&
      !excludedHR2026Sponsor.includes(sponsor.company_name)
  );

  // For PHA 2025 rearrange sponsor placement
  if (award_id == 123) {
    filteredSponsors = filteredSponsors.sort((a, b) => {
      const indexA = logoOrder.indexOf(a.company_name);
      const indexB = logoOrder.indexOf(b.company_name);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB; // both in list
      if (indexA !== -1) return -1; // a is in list
      if (indexB !== -1) return 1; // b is in list
      return 0; // neither in list
    });
  }

  if (award_id == 126) {
    filteredSponsors = filteredSponsors.sort((a, b) => {
      const indexA = logoOrderAIA2025.indexOf(a.company_name);
      const indexB = logoOrderAIA2025.indexOf(b.company_name);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB; // both in list
      if (indexA !== -1) return -1; // a is in list
      if (indexB !== -1) return 1; // b is in list
      return 0; // neither in list
    });
  }

  if (award_id == 127) {
    filteredSponsors = filteredSponsors.sort((a, b) => {
      const indexA = logoOrderCXIA2025.indexOf(a.company_name);
      const indexB = logoOrderCXIA2025.indexOf(b.company_name);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB; // both in list
      if (indexA !== -1) return -1; // a is in list
      if (indexB !== -1) return 1; // b is in list
      return 0; // neither in list
    });
  }

  if (award_id == 155) {
    filteredSponsors = filteredSponsors.sort((a, b) => {
      const indexA = logoOrderILTA2025.indexOf(a.company_name);
      const indexB = logoOrderILTA2025.indexOf(b.company_name);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB; // both in list
      if (indexA !== -1) return -1; // a is in list
      if (indexB !== -1) return 1; // b is in list
      return 0; // neither in list
    });
  }

  if (award_id == 134) {
    filteredSponsors = filteredSponsors.sort((a, b) => {
      const indexA = logoOrderFM2026.indexOf(a.company_name);
      const indexB = logoOrderFM2026.indexOf(b.company_name);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB; // both in list
      if (indexA !== -1) return -1; // a is in list
      if (indexB !== -1) return 1; // b is in list
      // console.log("filteredSponsors", filteredSponsors);
      return 0; // neither in list
    });
  }

  if (award_id == 156) {
    filteredSponsors = filteredSponsors.sort((a, b) => {
      const indexA = logoOrderFM2026.indexOf(a.company_name);
      const indexB = logoOrderFM2026.indexOf(b.company_name);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB; // both in list
      if (indexA !== -1) return -1; // a is in list
      if (indexB !== -1) return 1; // b is in list
      // console.log("filteredSponsors", filteredSponsors);
      return 0; // neither in list
    });
  }

  if (award_id == 140) {
    filteredSponsors = filteredSponsors.filter(sponsor =>
      logoWIFA2026.includes(sponsor.company_name)
    );
  }

  if (award_id == 151) {
    filteredSponsors = filteredSponsors.sort((a, b) => {
      const indexA = logoOrderFMUK2026.indexOf(a.company_name);
      const indexB = logoOrderFMUK2026.indexOf(b.company_name);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB; // both in list
      if (indexA !== -1) return -1; // a is in list
      if (indexB !== -1) return 1; // b is in list
      return 0; // neither in list
    });
  }

  if (award_id == 167) {
    filteredSponsors = filteredSponsors.sort((a, b) => {
      const indexA = logoOrderHR2026.indexOf(a.company_name);
      const indexB = logoOrderHR2026.indexOf(b.company_name);

      if (indexA !== -1 && indexB !== -1) return indexA - indexB; // both in list
      if (indexA !== -1) return -1; // a is in list
      if (indexB !== -1) return 1; // b is in list
      return 0; // neither in list
    });
  }

  if (award_id == 162) {
    filteredSponsors = filteredSponsors
      .filter(sponsor => !excludedCXIA2026Sponsor.includes(sponsor.company_name))
      .sort((a, b) => {
        const indexA = logoOrderCXIA2026.indexOf(a.company_name);
        const indexB = logoOrderCXIA2026.indexOf(b.company_name);

        if (indexA !== -1 && indexB !== -1) return indexA - indexB; // both in list
        if (indexA !== -1) return -1; // a is in list
        if (indexB !== -1) return 1; // b is in list
        return 0; // neither in list
      });
  }

  return (
    <div className="marquee-container">
      {sponsorsLoading ? null : (
        <Marquee autoFill={true}>
          {filteredSponsors.map((sponsor, index) => {
            let sponsor_logo = sponsor.image_url;

            // === IMAGE OVERRIDES ===
            if (award_id && award_id == 104) {
              if (sponsor.company_name == "Amárach Research" || sponsor.company_name == "Amarach Research") {
                sponsor_logo = "wipa/amarach.png";
              } else if (sponsor.company_name == "The Irish Times") {
                sponsor_logo = "the-irish-times.jpeg";
              } else if (sponsor.company_name == "Making Shift Happen") {
                sponsor_logo = "wipa/mhs.png";
              } else if (sponsor.company_name == "Cronin Group") {
                sponsor_logo = "wipa/cronin.png";
              } else if (sponsor.company_name == "Kuehne+Nagel") {
                sponsor_logo = "wipa/kuehne.png";
              } else if (sponsor.company_name == "Cognizant") {
                sponsor_logo = "wipa/cognizant.png";
              } else if (sponsor.company_name == "Cencora Pharmalex") {
                sponsor_logo = "wipa/cencora.png";
              }
            } else if (award_id && award_id == 121) {
              if (sponsor.company_name == "Kuehne + Nagel") {
                sponsor_logo = "piaie/kuehne.png";
              } else if (sponsor.company_name == "Cognizant") {
                sponsor_logo = "wipa/cognizant.png";
              } else if (sponsor.company_name == "Camida") {
                sponsor_logo = "piaie/camida.png";
              } else if (sponsor.company_name == "The Pharmaceutical Managers Institute (the PMI)") {
                sponsor_logo = "piaie/pmi.png";
              } else if (sponsor.company_name == "Controlled Environments Company") {
                sponsor_logo = "piaie/cec.png";
              } else if (sponsor.company_name == "Cronin Group") {
                sponsor_logo = "piaie/cronin.png";
              } else if (sponsor.company_name == "SGS Pharma") {
                sponsor_logo = "piaie/sgs.png";
              } else if (sponsor.company_name == "Shannon ABC") {
                sponsor_logo = "piaie/shannon.png";
              }
            } else if (award_id && award_id == 125) {
              if (sponsor.company_name == "SIG Workplace and Tarkett") {
                sponsor_logo = "foa/tarkett.png";
              } else if (sponsor.company_name == "MJF Interiors") {
                sponsor_logo = "foa/mjf.jpg";
              } else if (sponsor.company_name == "Ardmac") {
                sponsor_logo = "foa/ardmac.png";
              } else if (sponsor.company_name == "Whiteriver Group") {
                sponsor_logo = "foa/white-river.png";
              } else if (sponsor.company_name == "Solutions") {
                sponsor_logo = "foa/solutions.png";
              } else if (sponsor.company_name == "Vescom") {
                sponsor_logo = "foa/vescom.png";
              } else if (sponsor.company_name == "Total Fitout") {
                sponsor_logo = "foa/total-fitout.png";
              } else if (sponsor.company_name == "Cronin Group") {
                sponsor_logo = "piaie/cronin.png";
              } else if (sponsor.company_name == "Rockfon") {
                sponsor_logo = "foa/rockfon.png";
              }
            } else if (award_id && award_id == 127) {
              if (sponsor.company_name == "CXPA") {
                sponsor_logo = "cxia/cxpa.png";
              } else if (sponsor.company_name == "Abtran") {
                sponsor_logo = "cxia/abs.png";
              } else if (sponsor.company_name == "Workair") {
                sponsor_logo = "cxia/workair.png";
              }
            } else if (award_id && award_id == 132) {
              if (sponsor.company_name == "CarbonClick") {
                sponsor_logo = "carbonclick.png";
              } else if (sponsor.company_name == "Greenvolt Next") {
                sponsor_logo = "greenvolt-next.png";
              } else if (sponsor.company_name == "Shabra Plastics and Packaging Limited") {
                sponsor_logo = "shabra-group.png";
              } else if (sponsor.company_name == "Energia Group") {
                sponsor_logo = "energia-group.png";
              } else if (sponsor.company_name == "Roadstone") {
                sponsor_logo = "roadstone.jpg";
              } else if (sponsor.company_name == "Panda") {
                sponsor_logo = "panda.png";
              }
            } else if (award_id && award_id == 160) {
              if (sponsor.company_name == "ATC Training Limited") {
                sponsor_logo = "aiauk-2026/aviation-courses-logo.png";
              } else if (sponsor.company_name == "STS Engine Services") {
                sponsor_logo = "aiauk-2026/sts-engine-services-logo.png";
              }

            } else if (award_id && award_id == 167) {
              if (sponsor.company_name == "EPI-USE") {
                sponsor_logo = "hr2026/epi-use.png";
              } else if (sponsor.company_name == "NFP Ireland Management") {
                sponsor_logo = "hr2026/nfp.jpg";
              } else if (sponsor.company_name == "DeCare Dental") {
                sponsor_logo = "hr2026/decare.png";
              }

            } else {
              if (sponsor.company_name == "Amárach Research" || sponsor.company_name == "Amarach Research") {
                sponsor_logo = "amarach-research.png";
              } else if (sponsor.company_name == "The Irish Times") {
                sponsor_logo = "the-irish-times.jpeg";
              } else if (sponsor.company_name == "Panda") {
                sponsor_logo = "panda.png";
              } else if (sponsor.company_name == "HSI Skillko") {
                sponsor_logo = "hsi-skillko.png";
              } else if (sponsor.company_name == "Bretland") {
                sponsor_logo = "bretland.png";
              } else if (sponsor.company_name == "Axon Outsourcing Limited") {
                sponsor_logo = "axon.png";
              } else if (sponsor.company_name == "Sage") {
                sponsor_logo = "sage.png";
              } else if (sponsor.company_name == "Chartered Accountants Ireland") {
                sponsor_logo = "chartered.png";
              } else if (sponsor.company_name == "Financefair") {
                sponsor_logo = "financefair.png";
              } else if (sponsor.company_name == "ETL Global Ireland") {
                sponsor_logo = "etl.png";
              } else if (sponsor.company_name == "Saffery") {
                sponsor_logo = "saffery.png";
              } else if (sponsor.company_name == "NoFrixion") {
                sponsor_logo = "nofrixion.png";
              } else if (sponsor.company_name == "Iris Software Group") {
                sponsor_logo = "iris.png";
              } else if (sponsor.company_name == "Circit") {
                sponsor_logo = "circit.png";
              } else if (sponsor.company_name == "Search4Less") {
                sponsor_logo = "search4less.png";
              } else if (sponsor.company_name == "Mercia Ireland") {
                sponsor_logo = "mercia.png";
              } else if (sponsor.company_name == "Dornan Engineering Limited, A Turner Company") {
                sponsor_logo = "dornan.png";
              } else if (sponsor.company_name == "Mercury Engineering") {
                sponsor_logo = "mercury-engineering.png";
              } else if (sponsor.company_name == "The Sunday Times") {
                sponsor_logo = "the-sunday-times.png";
              } else if (sponsor.company_name == "Fit-O-Bonds") {
                sponsor_logo = "fit-o-bonds.png";
              } else if (sponsor.company_name == "Access Group") {
                sponsor_logo = "access-group.png";
              } else if (sponsor.company_name == "Steering Point") {
                sponsor_logo = "steering-point.png";
              }
            }

            // Overridden logos (e.g. Amárach) only exist as thumbnails, so keep those on the thumbnail path.
            const useFullResLogo = fullResLogoAwards.includes(Number(award_id)) && sponsor_logo === sponsor.image_url;
            const sponsor_logo_src = `${process.env.REACT_APP_URL}storage/agreements/${useFullResLogo ? "" : "thumbnails/"}${sponsor_logo}`;

            // === RENDER SPONSORS MARQUEE ===
            return (
              <div className="marquee-item" data-id={sponsor.id} key={index}>
                {sponsor.website ? (
                  <a href={sponsor.website} target="_blank" rel="noopener noreferrer">
                    <img
                      src={sponsor_logo_src}
                      alt={sponsor.company_name}
                      style={
                        award_id == 162 && logoHeightsCXIA2026[sponsor.company_name]
                          ? { height: logoHeightsCXIA2026[sponsor.company_name], width: "auto", objectFit: "contain" }
                          : award_id == 151 && logoHeightsFMUK2026[sponsor.company_name]
                          ? { height: logoHeightsFMUK2026[sponsor.company_name] }
                          : sponsor.company_name === "Pennypop" ||
                        sponsor.company_name === "Bunzl Ireland" ||
                        sponsor.company_name === "RFC Security Group"
                          ? { height: "4.5vw" }
                          : (award_id == 121 || award_id == 125) && sponsor.company_name == "Cronin Group"
                          ? { height: "3.5vw" }
                          : award_id == 125 && sponsor.company_name == "Walls Construction"
                          ? { height: "3.5vw" }
                          : sponsor.company_name == "Cronin Group" ||
                            sponsor.company_name == "Walls Construction"
                          ? { height: "2.5vw" }
                          : sponsor.company_name == "The Sunday Times"
                          ? { height: "1.7vw" }
                          : (award_id == 121 || award_id == 125 || award_id == 127) && sponsor.company_name == "Amárach Research"
                          ? { height: "4.5vw" } 
                          : sponsor.company_name == "Amárach Research" && award_id != 156 && award_id != 140
                          ? { height: "5vw" }
                          : sponsor.company_name == "PepTalk" ||
                            sponsor.company_name == "Hays Ireland" ||
                            sponsor.company_name == "CROWN"
                          ? { height: "1.7vw" }
                          : sponsor.company_name == "Medforce"
                          ? { height: "5.6vw" }
                          : award_id != 156 && award_id != 140 && (sponsor.company_name == "Servisource" ||
                            sponsor.company_name == "Doctify" || sponsor.company_name == "Amarach Research" || sponsor.company_name == "Amárach Research")
                          ? { height: "5.5vw" }
                          : sponsor.company_name == "Medica"
                          ? { height: "2.8vw" }
                          : sponsor.company_name == "Camida" || sponsor.company_name == "The Pharmaceutical Managers Institute (the PMI)" || sponsor.company_name == "Controlled Environments Company"
                          ? { height: "3.5vw" }
                          : award_id == 155 && sponsor.company_name == "Maersk Contract Logistics" 
                          ? { height: "3vw" }
                          : award_id == 155 && sponsor.company_name == "Irish International Freight Association" 
                          ? { height: "6vw" }
                          : award_id == 155 && (sponsor.company_name == "Amárach Research" || sponsor.company_name == "AIB" || sponsor.company_name == "ISM Recruitment & Training" || sponsor.company_name == "HSI Skillko")
                          ? { height: "4vw" }
                          : award_id == 155 && (sponsor.company_name == "Flexistaff Recruitment" || sponsor.company_name == "Manna Air Delivery")
                          ? { height: "5vw" }
                          : award_id == 132 && (sponsor.company_name == "CarbonClick" || sponsor.company_name == "Greenvolt Next")
                          ? { height: "2.5vw" }
                          : award_id == 132 && (sponsor.company_name == "Skillnet Climate Ready Academy")
                          ? { height: "4.5vw" }
                          : award_id == 132 && (sponsor.company_name == "Energia Group" || sponsor.company_name == "Sustainable Enterprise Skillnet")
                          ? { height: "5vw" }
                          : award_id == 132 && (sponsor.company_name == "Uisce Eireann" || sponsor.company_name == "ESB's Smart Energy Services"  || sponsor.company_name == "KINTO Join Ltd."  || sponsor.company_name == "Calor")
                          ? { height: "4vw" }
                          : award_id == 132 && (sponsor.company_name == "Panda")
                          ? { height: "3vw" }
                          : award_id == 134 && (sponsor.company_name == "Panda" || sponsor.company_name == "CBRE Global Workplace Solutions (GWS) Ireland")
                          ? { height: "3vw" }
                          : award_id == 134 && (sponsor.company_name == "Portobello Institute")
                          ? { height: "5vw" }
                          : award_id == 156 && (sponsor.company_name == "COMPASS EDUCATION")
                          ? { height: "4vw" }
                          : award_id == 156 && (sponsor.company_name == "SOLAS Skills to Advance")
                          ? { height: "3.5vw" }
                          : award_id == 156 && (sponsor.company_name == "Amárach Research")
                          ? { height: "3.5vw" }
                          : award_id == 140 && (sponsor.company_name == "Amárach Research")
                          ? { height: "3.5vw" }
                          : award_id == 174 && (sponsor.company_name == "Eland Cables")
                          ? { height: "6vw" }
                          : {}
                      }
                    />
                  </a>
                ) : (
                  <img
                    src={sponsor_logo_src}
                    alt={sponsor.company_name}
                    style={
                      award_id == 162 && logoHeightsCXIA2026[sponsor.company_name]
                          ? { height: logoHeightsCXIA2026[sponsor.company_name], width: "auto", objectFit: "contain" }
                          : award_id == 151 && logoHeightsFMUK2026[sponsor.company_name]
                        ? { height: logoHeightsFMUK2026[sponsor.company_name] }
                        : sponsor.company_name === "Pennypop" ||
                      sponsor.company_name === "Bunzl Ireland" ||
                      sponsor.company_name === "RFC Security Group"
                        ? { height: "4.5vw" }
                        : (award_id == 121 || award_id == 125) && sponsor.company_name == "Cronin Group"
                        ? { height: "3.5vw" }
                        : award_id == 125 && sponsor.company_name == "Walls Construction"
                        ? { height: "3.5vw" }
                        : sponsor.company_name == "Cronin Group" ||
                          sponsor.company_name == "Walls Construction"
                        ? { height: "2.5vw" }
                        : sponsor.company_name == "The Sunday Times"
                        ? { height: "1.7vw" }
                        : (award_id == 121 || award_id == 125 || award_id == 127) && sponsor.company_name == "Amárach Research"
                        ? { height: "4.5vw" } 
                        : award_id != 155 && award_id != 156 && award_id != 140 && sponsor.company_name == "Amárach Research"
                        ? { height: "5vw" }
                        : sponsor.company_name == "PepTalk" ||
                          sponsor.company_name == "Hays Ireland" ||
                          sponsor.company_name == "CROWN"
                        ? { height: "1.7vw" }
                        : sponsor.company_name == "Medforce"
                        ? { height: "5.6vw" }
                        : award_id != 155 && award_id != 156 && award_id != 140 && (sponsor.company_name == "Servisource" || sponsor.company_name == "Doctify" || sponsor.company_name == "Amarach Research" || sponsor.company_name == "Amárach Research")
                        ? { height: "5.5vw" }
                        : sponsor.company_name == "Medica"
                        ? { height: "2.8vw" }
                        : sponsor.company_name == "Camida" || sponsor.company_name == "The Pharmaceutical Managers Institute (the PMI)" || sponsor.company_name == "Controlled Environments Company"
                        ? { height: "3.5vw" }
                        : award_id == 155 && sponsor.company_name == "Maersk Contract Logistics" 
                        ? { height: "3vw" }
                        : award_id == 155 && sponsor.company_name == "Irish International Freight Association" 
                        ? { height: "6vw" }
                        : award_id == 155 && (sponsor.company_name == "Amárach Research" || sponsor.company_name == "AIB" || sponsor.company_name == "ISM Recruitment & Training" || sponsor.company_name == "HSI Skillko")
                        ? { height: "4vw" }
                        : award_id == 155 && (sponsor.company_name == "Flexistaff Recruitment" || sponsor.company_name == "Manna Air Delivery")
                        ? { height: "5vw" }
                        : award_id == 132 && (sponsor.company_name == "CarbonClick" || sponsor.company_name == "Greenvolt Next")
                        ? { height: "2.5vw" }
                        : award_id == 132 && (sponsor.company_name == "Skillnet Climate Ready Academy")
                        ? { height: "4.5vw" }
                        : award_id == 132 && (sponsor.company_name == "Energia Group" || sponsor.company_name == "Sustainable Enterprise Skillnet" || sponsor.company_name == "KINTO Join Ltd."  || sponsor.company_name == "Calor")
                        ? { height: "5vw" }
                        : award_id == 132 && (sponsor.company_name == "Uisce Eireann" || sponsor.company_name == "ESB's Smart Energy Services")
                        ? { height: "4vw" }
                        : award_id == 132 && (sponsor.company_name == "Panda")
                        ? { height: "3vw" }
                        : award_id == 134 && (sponsor.company_name == "Panda" || sponsor.company_name == "CBRE Global Workplace Solutions (GWS) Ireland")
                        ? { height: "3vw" }
                        : award_id == 134 && (sponsor.company_name == "Portobello Institute")
                        ? { height: "5vw" }
                        : award_id == 156 && (sponsor.company_name == "COMPASS EDUCATION")
                        ? { height: "4vw" }
                        : award_id == 156 && (sponsor.company_name == "SOLAS Skills to Advance")
                        ? { height: "3.5vw" }
                        : award_id == 156 && (sponsor.company_name == "Amárach Research")
                        ? { height: "3.5vw" }
                        : award_id == 140 && (sponsor.company_name == "Amárach Research")
                        ? { height: "3.5vw" }
                        : award_id == 174 && (sponsor.company_name == "Eland Cables")
                        ? { height: "6vw" }
                        : {} 
                        
                    }
                  />
                )}
              </div>
            );
          })}
          {award_id == 108 || award_id == 109 || award_id == 124 || award_id == 131 || award_id == 164 || award_id == 155 || award_id == 161 || award_id == 160 || award_id == 172 || award_id == 151 || award_id == 167 || award_id == 174 || award_id == 162 ?
            <div className="marquee-item">
              <a href="https://businessriver.com" target="_blank" rel="noopener noreferrer">
                <img
                  src={`${process.env.REACT_APP_URL}storage/logo/Business-River-Logo.png`}
                  alt="Business River"
                  style={award_id == 162 ? { height: logoHeightsCXIA2026["Business River"], width: "auto", objectFit: "contain" } : { height: "4.5vw" }}
                />
              </a>
            </div>
            :
            null
          }
        </Marquee>
      )}
    </div>
  );
};

export default SponsorsMarqueeV2;
